import { createNS } from '@/utils/actionCreator';

export const NS = createNS('BILLING');
